import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-txc-prototype',
  templateUrl: './txc-prototype.component.html',
  styleUrls: ['./txc-prototype.component.scss']
})
export class TxcPrototypeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
